import { Button } from "@newsela/angelou";

import CloseIcon from "@/icons/CloseIcon";
import PauseIcon from "@/icons/PauseIcon";
import PlayIcon from "@/icons/PlayIcon";
import RestartIcon from "@/icons/RestartIcon";
import UndoIcon from "@/icons/UndoIcon";
import focusElementRefKeys from "@/view/constants/focusElementRefKeys";
import { buttonCss } from "../ReadAloudControls.style";

const sharedProps = {
  objectName: "Content",
  actionName: "Read",
  __cssFor: { root: buttonCss },
};

const readAloudButtonsConfig = (
  speech,
  streamProperties,
  handleClose,
  setFocusManagerRef,
  handlePause,
  disabled,
) => {
  return {
    playPause: {
      ref: (ref) => {
        setFocusManagerRef(ref, focusElementRefKeys.readAloudPlayPauseButton);
      },
      ariaProps: {
        "aria-label": speech.isPlaying
          ? "Pause read aloud audio"
          : "Play read aloud audio",
      },
      dataProps: {
        "data-qa-selector": speech.isPlaying
          ? "pause-read-aloud"
          : "play-read-aloud",
      },
      disabled,
      flavor: Button.flavors.secondary,
      onClick: handlePause,
      Icon: speech.isPlaying ? PauseIcon : PlayIcon,
      ...sharedProps,
      streamProperties: {
        ...streamProperties,
        description: speech.isPlaying
          ? "Pause read aloud audio"
          : "Play read aloud audio",
      },
    },
    restart: {
      ariaProps: { "aria-label": "Reset read aloud audio" },
      dataProps: { "data-qa-selector": "restart-read-aloud" },
      flavor: Button.flavors.secondary,
      Icon: RestartIcon,
      onClick: speech.resetAudio,
      ...sharedProps,
      streamProperties: {
        ...streamProperties,
        description: "Reset read aloud audio",
      },
    },
    jumpBack: {
      ariaProps: { "aria-label": "Jump back read aloud controls" },
      dataProps: { "data-qa-selector": "jump-back-read-aloud" },
      flavor: Button.flavors.secondary,
      Icon: UndoIcon,
      onClick: speech.jumpBack,
      ...sharedProps,
      streamProperties: {
        ...streamProperties,
        description: "Jump back read aloud controls",
      },
    },
    close: {
      ariaProps: { "aria-label": "Close read aloud controls" },
      dataProps: { "data-qa-selector": "close-read-aloud" },
      flavor: Button.flavors.incognito,
      Icon: CloseIcon,
      onClick: handleClose,
      ...sharedProps,
      streamProperties: {
        ...streamProperties,
        description: "Close read aloud controls",
      },
    },
  };
};

export default readAloudButtonsConfig;
